if (!customElements.get("nss-sign-up-form")) {
    customElements.define("nss-sign-up-form", class NSSSignUpForm extends HTMLElement {
        constructor() {
            super();
            this.selectors = {
                toggle: ".js-nss-sign-up-form-toggle a",
                content: ".js-nss-sign-up-form-content",
                success: ".js-nss-sign-up-form-success",
                formContent: ".js-nss-sign-up-form-form-content"
            };
            this.toggle = this.querySelectorAll(this.selectors.toggle);
            this.content = this.querySelector(this.selectors.content);
            this.success = this.querySelector(this.selectors.success);
            this.formContent = this.querySelector(this.selectors.formContent);
            this.init();
        }

        init() {
            if (window.location.search.includes("customer_posted=true") && window.location.hash == "#nss-sign-up-form") {
                this.content?.classList.add("is-open");
                this.success?.classList.add("is-show");
                this.formContent.style.display = "none";
            }

            this.toggle.forEach(el => {
                el.addEventListener("click", (e) => {
                    e.preventDefault();
                    this.content?.classList.toggle("is-open");
                })
            })
        }
    })
}